<template>
    <ion-page class="ion-page" id="main">
        <default-header>
            <template v-slot:start>
                <ion-buttons slot="start">
                    <router-link :to="{ name: 'incoming-mail'}">
                        <ion-button>
                            <ion-icon ios='arrow-back' md="arrow-back" slot="start"/>

                            <span class="ion-hide-sm-down">{{ $t('ncrypt.incoming_mail.title') }}</span>

                            <span class="ion-hide-sm-up">{{ $t('ncrypt.back') }}</span>
                        </ion-button>
                    </router-link>
                </ion-buttons>
            </template>

            <template>
                <ion-title class="ion-hide-sm-down">
                    {{ $t('ncrypt.received_message') }}
                </ion-title>
            </template>
        </default-header>

        <ion-content fullscreen>
            <flash-messages/>

            <incoming-mail-message :message="message" />
        </ion-content>
    </ion-page>
</template>
<script>
    import FlashMessages from "../components/ui-elements/FlashMessages";
    import DefaultHeader from "../components/nav/DefaultHeader";
    import IncomingMailMessage from "../components/messages/IncomingMailMessage";

    export default {
        components: {
            IncomingMailMessage,
            DefaultHeader,
            FlashMessages,
        },
        data() {
            return {
                message: undefined,
            }
        },
        methods: {
            loadMainMessage() {
                this.retrieveMessage(this.$route.params.id).then(message => this.message = message);
            },
            retrieveMessage(id) {
                return new Promise(resolve => {
                    this.$http
                        .get(`/incoming-mail/${id}`)
                        .then(({data: response}) => resolve(response.data))
                        .catch(error => window.console.error(error));
                });
            },
        },
        created() {
            this.loadMainMessage();
        },
    }
</script>
